import React, { useContext } from "react"
import styled from "styled-components"
import { ButtonLink } from "../../atoms/buttons"
import { Eventlogo } from "../../atoms/logo"
import { withLightbox } from "../lightbox"
import { Link, StaticQuery, graphql } from "gatsby"
import SiteContext from "../../../context/SiteContext"

import find from "lodash.find"

const Mobilestyled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  transition: transform 175ms ease-in-out;
  transform: ${props => (props.toggle ? "translateX(0)" : "translateX(-105%)")};
  box-shadow: 3px 0 6px #00000029;
  height: 100vh;
  overflow-y: scroll;
  width: 95vw;
  max-width: 360px;
  background: #fff;
  z-index: 998;
  text-align: center;
  .logo {
    max-width: 120px;
    margin: 5rem auto 2rem;
  }
  .button {
    margin-bottom: 2rem;
    button {
      width: 90%;
      margin: 0 auto;
    }
  }
  .close {
    font-size: 1.7rem;
    font-weight: 700;
    position: absolute;
    top: 1.5rem;
    right: 1.5rem;
  }
`

const Links = styled.div`
  position: relative;
  padding: 0 0 6rem;
  > div {
    text-align: left !important;
    width: 80%;
    margin: 0 auto;
  }
  .link-wrap {
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    padding: 1rem 0;
  }
  a {
    text-decoration: none;
  }
  .inner {
    a {
      margin-left: 1.5rem;
      color: #000;
    }
    display: none;
  }
  .inner.active {
    display: block;
  }
`

const Mobile = ({ toggle, callback, selected, setSelected }) => {
  const context = useContext(SiteContext)
  return (
    <StaticQuery
      query={graphql`
        query {
          allContentfulMainNavigation {
            edges {
              node {
                title
                navigationGroups {
                  pages {
                    id
                    slug
                    title
                  }
                  slug
                  title
                }
              }
            }
          }
        }
      `}
      render={data => (
        <Mobilestyled toggle={toggle}>
          <div className="constraint">
            <div className="close">
              <a alt="close" onClick={callback}>
                X
              </a>
            </div>
            <Link to="/">
              <Eventlogo />
            </Link>
            {/* 
            <div className="button">
              <ButtonLink
                track={
                  context.trade === true
                    ? "DC-6953330/sgair0/fronc00+per_session"
                    : false
                }
                text={
                  context.trade === true || context.trade === "true"
                    ? "REGISTER"
                    : "PURCHASE TICKETS"
                }
                external={
                  context.trade === true || context.trade === "true"
                    ? true
                    : true
                }
                slug={
                  context.trade === true || context.trade === "true"
                    ? "https://app.singaporeairshow.com/"
                    : "https://www.sistic.com.sg/events/sas1502"
                }
                type={"solid"}
              />
            </div>
            */}
          </div>
          <Links>
            {find(data.allContentfulMainNavigation.edges, function(edge) {
              return context.trade === true || context.trade === "true"
                ? edge.node.title === "Trade Links"
                : edge.node.title === "Public Links"
            }).node.navigationGroups.map((link, i) => (
              <div key={i}>
                {link.slug ? (
                  /^(http|https):/.test(link.slug) === true ? (
                    <div className="link-wrap" onClick={() => setSelected(i)}>
                      <a href={link.slug} target="_blank">
                        {link.title}
                      </a>
                    </div>
                  ) : (
                    <div className="link-wrap" onClick={() => setSelected(i)}>
                      <Link to={link.slug}>{link.title}</Link>
                    </div>
                  )
                ) : (
                  <div className="link-wrap" onClick={() => setSelected(i)}>
                    <a>{link.title}</a>
                  </div>
                )}
                {link.pages ? (
                  <div className={selected === i ? "inner active" : "inner"}>
                    {link.pages.map((linked, i) => {
                      return /^(http|https):/.test(linked.slug) !== true ? (
                        <div className="link-wrap" key={i}>
                          <Link to={linked.slug}>{linked.title}</Link>
                        </div>
                      ) : (
                        <div className="link-wrap" key={i}>
                          <a href={linked.slug} target="_blank">
                            {linked.title}
                          </a>
                        </div>
                      )
                    })}
                  </div>
                ) : (
                  ""
                )}
              </div>
            ))}
            {/*
            <div> 
              <div className="link-wrap">
                <Link
                  to={
                    context.trade === true || context.trade === "true"
                      ? "/public"
                      : "/trade"
                  }
                >
                  {context.trade === true || context.trade === "true"
                    ? "GO TO PUBLIC SITE"
                    : "GO TO TRADE SITE"}{" "}
                </Link>
              </div>
            </div>
            */}
          </Links>
        </Mobilestyled>
      )}
    />
  )
}

export const MobileMenu = withLightbox(Mobile)
